export default "__VITE_ASSET__Dz41eZGz__"